define(function(require) {
    'use strict';
    var AppConfig = require('config/application');
    var Model = require('models/integratedEmail');

    return Backbone.Collection.extend({
        url: AppConfig.host + '/rest/integrations/email/api',
        model: Model
    });
});